import Model from "@/lib/model/model";

export default class ViConfig extends Model {
  id = "";
  jumpUrl = "";
  mobileSign = "";
  source = "";
  specialLogoOss = "";
}
